module["exports"] = [
  "#{city_prefix}"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/es/address/city.js
 ** module id = 579
 ** module chunks = 0
 **/